import rules from "@/utils/rules";
export default [
    {
        name: 'Фамилия',
        type: 'input',
        typeInput: 'text',
        disabled: false,
        cols: 3,
        rules: [rules.required,  rules.rus],
        dataField: 'firstName',
    },
    {
        name: 'Имя',
        type: 'input',
        typeInput: 'text',
        disabled: false,
        cols: 3,
        rules: [rules.required,rules.rus],
        dataField: 'lastName',
    },
    {
        name: 'Отчество',
        type: 'input',
        typeInput: 'text',
        disabled: false,
        cols: 3,
        rules: [rules.required,  rules.rus],
        dataField: 'secondName',
    },
    {
        name: 'Должность',
        type: 'input',
        disabled: false,
        cols: 3,
        rules: [rules.required, rules.counter3, rules.dolg, rules.rus],
        dataField: 'position',
    },
    {
        name: 'Фамилия (в родительном падеже)',
        type: 'input',
        typeInput: 'text',
        disabled: false,
        cols: 3,
        rules: [rules.required, rules.rus],
        dataField: 'firstNameRP',
    },
    {
        name: 'Имя (в родительном падеже)',
        type: 'input',
        typeInput: 'text',
        disabled: false,
        cols: 3,
        rules: [rules.required,  rules.rus],
        dataField: 'lastNameRP',
    },
    {
        name: 'Отчество (в родительном падеже)',
        type: 'input',
        typeInput: 'text',
        disabled: false,
        cols: 3,
        rules: [rules.required, rules.rus],
        dataField: 'secondNameRP',
    },
    {
        name: 'Должность (в родительном падеже)',
        type: 'input',
        disabled: false,
        cols: 3,
        rules: [rules.required, rules.counter3, rules.dolg, rules.rus],
        dataField: 'positionRP',
    },
    {
        name: 'Электронная почта',
        type: 'input',
        typeInput: 'text',
        rules: [rules.email],
        disabled: false,
        cols: 3,
        dataField: 'email',
    },

    {
        name: 'Рабочий телефон (с кодом города)',
        type: 'telephone',
        cols: 3,
        disabled: false,
        dataField: 'workPhoneNumber',
    },
    {
        name: 'Добавочный номер',
        type: 'input',
        cols: 3,
        disabled: false,
        rules: [],
        dataField: 'workPhoneExtension',
    },

    {
        name: 'Мобильный телефон',
        type: 'telephone',
        cols: 3,
        disabled: false,
        dataField: 'personalPhoneNumber',
    },
]
